<template>
  <div
    class="crew-labor-edit flex w-full justify-start"
    style="flex-direction: column"
  >
    <div
      ref="crewEditForm"
      class="py-4"
      style="
        height: calc(100vh - 160px);
        overflow-y: scroll;
        margin: 0 0 0 1rem;
      "
    >
      <div class="mb-8 required aisea-text-16-400-black">
        必要事項を入力してください。「<label></label>」は入力必須項目です。
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full">
          <label class="header-label">労務情報テンプレート</label>
          <v-select
            placeholder="-"
            v-model="selectedTemplate"
            class="w-full required"
            name="templates"
            label="label"
            :options="templates"
            :clearable="false"
            @input="inputTemplate"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('label')"
            >{{ errors.first("label") }}</span
          >
        </div>
      </div>

      <div
        class="
          flex
          w-full
          justify-start
          items-start
          crew-edit-form-row
          required
        "
      >
        <label class="header-label">労務管理責任者</label>
        <vs-input
          placeholder="例) 海運 一郎"
          class="w-full required"
          v-model="localData.labor_mgmt_rep"
          v-validate="'required'"
          name="labor_mgmt_rep"
          data-vv-as="労務管理責任者"
          :color="AISEA_COLOR.BLUE"
        />
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('labor_mgmt_rep')"
          >{{ errors.first("labor_mgmt_rep") }}</span
        >
      </div>

      <div class="w-full justify-start items-start crew-edit-form-row required">
        <label class="header-label">基準労働期間</label>
        <v-select
          placeholder="選択"
          class="w-full"
          v-model="WorkPeriodMonth"
          name="work_period_month"
          :options="workingPeriods"
          :clearable="false"
          @input="inputWorkPeriodMonth"
        />
        <p class="description_label">
          ※休日・補償休日を清算する期間。12カ月以内で設定。
        </p>
      </div>

      <div
        class="
          flex
          w-full
          justify-start
          items-start
          crew-edit-form-row
          required
        "
      >
        <label class="header-label">基準労働期間起算日</label>
        <div class="flex items-center pb-2">
          <div>
            <v-select
              placeholder="選択"
              style="width: 104px"
              name="work_period_from_year"
              :options="yearSelect()"
              v-model="workingPeriodFromYear"
              v-validate="'required'"
              data-vv-as="起算日（年）"
              :clearable="false"
            />
          </div>
          <span class="m-2">/</span>
          <div>
            <v-select
              placeholder="選択"
              style="width: 104px"
              name="work_period_from_month"
              :options="monthSelect()"
              v-model="workingPeriodFromMonth"
              v-validate="'required'"
              data-vv-as="起算日（月）"
              :clearable="false"
            />
          </div>
          <span class="m-2">/</span>
          <div>
            <v-select
              placeholder="選択"
              style="width: 104px"
              :disabled="inputFromMonth()"
              v-model="workingPeriodFromDay"
              v-validate="'required'"
              name="work_period_from_day"
              data-vv-as="起算日（日）"
              :options="
                daySelect(
                  workingPeriodFromYear.label,
                  workingPeriodFromMonth.label
                )
              "
              :clearable="false"
            />
          </div>
        </div>
        <p class="description_label">※基準労働期間の起算日を選択</p>
        <p class="description_label">※03月01日〜04月30日の場合、03/01と入力</p>
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_from_year')"
          >{{ errors.first("work_period_from_year") }}</span
        >
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_from_month')"
          >{{ errors.first("work_period_from_month") }}</span
        >
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_from_day')"
          >{{ errors.first("work_period_from_day") }}</span
        >
        <div
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="isDuplicateWorkPeriod"
        >
          <p>過去の基準労働期間と重複する内容は登録できません。</p>
          <p>【重複する基準労働期間】</p>
          <p v-for="(date, index) in duplicateDates" :key="index" class="pl-4">
            {{ date.from }} 〜 {{ date.to }}
          </p>
        </div>
      </div>

      <div
        class="
          flex
          w-full
          justify-start
          items-start
          crew-edit-form-row
          required
        "
      >
        <label class="header-label">基準労働期間末日</label>
        <div class="flex items-center pb-2">
          <div>
            <v-select
              placeholder="選択"
              style="width: 104px"
              :options="yearSelect()"
              v-model="workingPeriodToYear"
              name="work_period_to_year"
              v-validate="'required'"
              data-vv-as="末日（年）"
              :clearable="false"
            />
          </div>
          <span class="m-2">/</span>
          <div>
            <v-select
              placeholder="-"
              style="width: 104px"
              v-model="workingPeriodToMonth"
              name="work_period_to_month"
              v-validate="'required'"
              data-vv-as="末日（月）"
              :options="monthSelect()"
              :clearable="false"
            />
          </div>
          <span class="m-2">/</span>
          <div>
            <v-select
              placeholder="-"
              style="width: 104px"
              :disabled="inputToMonth()"
              v-model="workingPeriodToDay"
              name="work_period_to_day"
              v-validate="'required'"
              data-vv-as="末日（日）"
              :options="
                daySelect(workingPeriodToYear.label, workingPeriodToMonth.label)
              "
              :clearable="false"
            />
          </div>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('mandatory_day_off')"
            >{{ errors.first("mandatory_day_off") }}</span
          >
        </div>
        <p class="description_label">※基準労働期間の末日を選択</p>
        <p class="description_label">※03月01日～04月30日の場合、04/30と入力</p>
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_to_year')"
          >{{ errors.first("work_period_to_year") }}</span
        >
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_to_month')"
          >{{ errors.first("work_period_to_month") }}</span
        >
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_to_day')"
          >{{ errors.first("work_period_to_day") }}</span
        >
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">時間外労使協定の有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="overtimeLaborAgrmt"
            v-validate="'required'"
            name="overtime_labor_agrmt"
            data-vv-as="時間外労使協定の有無"
            :options="boolSelect()"
            :clearable="false"
            @input="inputOvertimeLaborAgrmt"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('overtime_labor_agrmt')"
            >{{ errors.first("overtime_labor_agrmt") }}</span
          >
          <p class="description_label">
            ※時間外労働を認める旨の協定。事前に組合等と書面で締結し、所轄地方運輸局に提出しているもの（労働協約内に含まれることもあり）
          </p>
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">補償休日労働協定の有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="compensatoryTimeOffLaborAgrmt"
            v-validate="'required'"
            name="compensatory_time_off_labor_agrmt"
            data-vv-as="補償休日労働協定の有無"
            :options="boolSelect()"
            :clearable="false"
            @input="inputCompensatoryTimeOffLaborAgrmt"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('compensatory_time_off_labor_agrmt')"
            >{{ errors.first("compensatory_time_off_labor_agrmt") }}</span
          >
          <p class="description_label">
            ※補償休日であっても労働をさせることができる旨の協定（労働協約内に含まれることもあり）
          </p>
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">休息時間分割回数協定の有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="breakLaborAgrmt"
            v-validate="'required'"
            name="break_labor_agrmt"
            data-vv-as="休息時間分割回数協定の有無"
            :options="boolSelect()"
            :clearable="false"
            @input="inputBreakLaborAgrmt"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('break_labor_agrmt')"
            >{{ errors.first("break_labor_agrmt") }}</span
          >
          <p class="description_label">
            ※休息時間を3分割以上、もしくは分割時の長い方の休息時間を6時間未満とすることができる旨の協定（労働協約内に含まれることもあり）
          </p>
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">休日日数の定めの有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="mandatoryDayOff"
            v-validate="'required'"
            name="mandatory_day_off"
            data-vv-as="休日日数の定めの有無"
            :clearable="false"
            :options="boolSelect()"
            @input="inputMandatoryDayOff"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('mandatory_day_off')"
            >{{ errors.first("mandatory_day_off") }}</span
          >
          <p class="description_label">
            ※施行規則第42条の２第３項に基づく休日の日数の定めの有無を選択
          </p>
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div
          class="w-full required"
          :class="{ 'disabled-area': !localData.mandatory_day_off }"
        >
          <label class="header-label">休日日数を定めている場合の日数</label>
          <vs-input
            :disabled="!localData.mandatory_day_off"
            placeholder=""
            class="w-full"
            v-model="localData.num_of_mandatory_day_off"
            v-validate="'numeric|max_value:365|min_value:1'"
            name="num_of_mandatory_day_off"
            data-vv-as="休日日数を定めている場合の日数"
            :color="AISEA_COLOR.BLUE"
            :clearable="false"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('num_of_mandatory_day_off')"
            >{{ errors.first("num_of_mandatory_day_off") }}</span
          >
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('custom_num_of_mandatory_day_off')"
            >{{ errors.first("custom_num_of_mandatory_day_off") }}</span
          >

          <p class="description_label">
            ※上記で「有」を選択した場合に、労働協約、就業規則等において定められている、基準労働期間内に与える休日の日数を記載
          </p>
        </div>
      </div>

      <div class="w-full justify-start items-start crew-edit-form-row">
        <div class="required">
          <label class="header-label">有給休暇の必要日数</label>
          <vs-input
            placeholder="例)120"
            class="w-full"
            v-model="localData.num_of_mandatory_paid_time_off"
            v-validate="'required|numeric|max_value:365|min_value:1'"
            name="num_of_mandatory_paid_time_off"
            data-vv-as="有給休暇の必要日数"
            :color="AISEA_COLOR.BLUE"
            :clearable="false"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('num_of_mandatory_paid_time_off')"
            >{{ errors.first("num_of_mandatory_paid_time_off") }}</span
          >
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">法第72条特例への該当有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="marinersLawArt72Applicable"
            v-validate="'required|max:32'"
            name="mariners_law_art_72_applicable"
            data-vv-as="法第72条特例への該当有無"
            :clearable="false"
            :options="boolSelect()"
            @input="inputMarinersLawArt72Applicable"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('mariners_law_art_72_applicable')"
            >{{ errors.first("mariners_law_art_72_applicable") }}</span
          >
        </div>
      </div>

      <div
        class="
          flex
          w-full
          justify-start
          items-start
          crew-edit-form-row
          required
        "
        :class="{ 'disabled-area': !localData.mariners_law_art_72_applicable }"
      >
        <div class="w-full">
          <label class="header-label">1日あたり労働時間上限</label>
          <v-select
            placeholder=""
            class="w-full"
            :disabled="!localData.mariners_law_art_72_applicable"
            v-model="maxWorkHourPerDay"
            name="max_work_hour_per_day"
            data-vv-as="1日あたり労働時間上限"
            :options="timeSelect"
            :clearable="false"
            @input="inputMaxWorkHourPerDay"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('max_work_hour_per_day')"
            >{{ errors.first("max_work_hour_per_day") }}</span
          >
          <p class="description_label">
            ※時間外労働が認められていたとしても、1日14時間を超えてはならない
          </p>
        </div>
      </div>

      <vs-divider style="margin: 0" />

      <div class="flex w-full justify-end items-center">
        <div style="margin: 0.8rem">
          <vs-button
            type="border"
            style="width: 6rem; padding: 0.4rem"
            @click="onCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div style="margin: 0.8rem">
          <vs-button
            :disabled="!validate"
            :color="AISEA_COLOR.BLUE"
            style="width: 6rem; padding: 0.4rem"
            @click="onSubmit()"
            >保存</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import vSelect from "vue-select";
import moment from "moment";
import _ from "lodash";

import { createNamespacedHelpers } from "vuex";
const {
  mapState: mapStateTemplate,
  mapActions: mapActionsTemplate,
} = createNamespacedHelpers("crewLaborTemplate");
const {
  mapGetters: mapGettersLabor,
  mapActions: mapActionsLabor,
  mapState: mapStateLabor,
} = createNamespacedHelpers("crewLabor");
import { DateUtil } from "@/utils";

export default {
  mixins: [ColorMixin],
  name: "CrewLaborsEdit",
  components: {
    vSelect,
  },
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
  },
  data() {
    return {
      localData: {},
      workingPeriod: null,
      WorkPeriodMonth: "",
      workingPeriodFromYear: "",
      workingPeriodFromMonth: "",
      workingPeriodFromDay: "",
      workingPeriodToYear: "",
      workingPeriodToMonth: "",
      workingPeriodToDay: "",
      maxWorkHourPerDay: null,
      overtimeLaborAgrmt: null,
      compensatoryTimeOffLaborAgrmt: null,
      breakLaborAgrmt: null,
      mandatoryDayOff: null,
      marinersLawArt72Applicable: null,
      selectedTemplate: {},
      version: null,
      laborId: null,
      duplicateWorkPeriodFrom: null,
      duplicateWorkPeriodTo: null,
      duplicateDates: [],
    };
  },
  computed: {
    ...mapStateTemplate(["templates"]),
    ...mapGettersLabor(["crewName"]),
    ...mapStateLabor(["labors"]),
    validate() {
      const checkMandatoryDayOff = this.validateMandatoryDayOff();
      const checkMaxWorkHourPerDay = this.validateMaxWorkHourPerDay();

      if (
        this.errors.any() ||
        !checkMandatoryDayOff ||
        !checkMaxWorkHourPerDay ||
        this.isDuplicateWorkPeriod
      ) {
        return false;
      }

      return true;
    },
    timeSelect() {
      return Array.from({ length: 14 }, (_, index) => {
        return {
          label: `${index + 1}時間`,
          value: index + 1,
        };
      });
    },
    workingPeriods() {
      return Array.from({ length: 12 }, (_, index) => {
        return {
          label: `${index + 1}ヶ月`,
          value: index + 1,
        };
      });
    },
    defaultTemplate() {
      if (!this.templates) return undefined;
      return this.templates.find(t => t.is_default);
    },
    isDuplicateWorkPeriod() {
      return this.duplicateDates.length > 0;
    },
  },
  watch: {
    activeSidebarCrew(val) {
      if (!val) return;
      this.$validator.reset();
    },

    WorkPeriodMonth() {
      this.calcWorkPeriodToDate();
    },

    workingPeriodFromYear() {
      this.calcFromDay();
      this.calcWorkPeriodToDate();
      this.setWorkPeriodRange();
    },

    workingPeriodFromMonth() {
      this.calcFromDay();
      this.calcWorkPeriodToDate();
      this.setWorkPeriodRange();
    },
    workingPeriodFromDay() {
      this.calcWorkPeriodToDate();
      this.setWorkPeriodRange();
    },

    workingPeriodToYear() {
      this.calcToDay();
      this.setWorkPeriodRange();
    },

    workingPeriodToMonth() {
      this.calcToDay();
      this.setWorkPeriodRange();
    },
  },
  methods: {
    ...mapActionsTemplate(["fetchTemplateList"]),
    ...mapActionsLabor([
      "addLabor",
      "updateLabor",
      "fetchCrew",
      "fetchLaborPeriodList",
    ]),

    calcFromDay() {
      if (
        !this.WorkPeriodMonth.value ||
        !this.workingPeriodFromMonth.value ||
        !this.workingPeriodFromDay.value ||
        !this.workingPeriodFromYear.value
      )
        return;
      const fromYYYY = this.workingPeriodFromYear.label;
      const fromMM = this.workingPeriodFromMonth.label;
      const lastDay = moment(`${fromYYYY}${fromMM}01`, "YYYYMMDD")
        .endOf("month")
        .format("DD");

      if (Number(lastDay) > this.workingPeriodFromDay.value) return;

      this.workingPeriodFromDay = {
        label: lastDay,
        value: Number(lastDay),
      };
    },

    calcToDay() {
      if (
        !this.WorkPeriodMonth.value ||
        !this.workingPeriodToMonth.value ||
        !this.workingPeriodToDay.value ||
        !this.workingPeriodToYear.value
      )
        return;
      const toYYYY = this.workingPeriodToYear.label;
      const toMM = this.workingPeriodToMonth.label;
      const lastDay = moment(`${toYYYY}${toMM}01`, "YYYYMMDD")
        .endOf("month")
        .format("DD");

      if (Number(lastDay) > this.workingPeriodToDay.value) return;

      this.workingPeriodToDay = {
        label: lastDay,
        value: Number(lastDay),
      };
    },

    async calcWorkPeriodToDate() {
      if (
        !this.WorkPeriodMonth.value ||
        !this.workingPeriodFromMonth.value ||
        !this.workingPeriodFromDay.value ||
        !this.workingPeriodFromYear.value
      )
        return;

      const fromYmd = `${this.workingPeriodFromYear.value}-${(
        "00" + this.workingPeriodFromMonth.value
      ).slice(-2)}-${("00" + this.workingPeriodFromDay.value).slice(-2)}`;

      const isLastDayFrom =
        this.workingPeriodFromDay.label ===
        moment(fromYmd, "YYYYMMDD")
          .endOf("month")
          .format("DD");

      let toYmdMoment;

      if (isLastDayFrom) {
        //fromが月末の場合、toも月末
        toYmdMoment = moment(fromYmd, "YYYYMMDD")
          .add(this.WorkPeriodMonth.value, "month")
          .endOf("month");
      } else {
        //上記以外の場合、toはfrom-1日
        toYmdMoment = moment(fromYmd, "YYYYMMDD")
          .add(this.WorkPeriodMonth.value, "month")
          .add(-1, "days");
      }

      const toYYYY = toYmdMoment.format("YYYY");
      const toMM = toYmdMoment.format("MM");
      const toDD = toYmdMoment.format("DD");

      this.workingPeriodToYear = {
        label: `${toYYYY}`,
        value: toYYYY,
      };
      this.workingPeriodToMonth = {
        label: toMM,
        value: Number(toMM),
      };
      this.workingPeriodToDay = {
        label: toDD,
        value: Number(toDD),
      };
    },

    async setWorkPeriodRange() {
      const _workPeriodFromString = new Date(
        `${this.workingPeriodFromYear.value}/${this.workingPeriodFromMonth.value}/${this.workingPeriodFromDay.value}`
      ).toISOString();
      const _workPeriodToString = new Date(
        `${this.workingPeriodToYear.value}/${this.workingPeriodToMonth.value}/${this.workingPeriodToDay.value}`
      ).toISOString();

      this.localData.work_period_from = moment(_workPeriodFromString).format(
        "YYYY-MM-DD"
      );
      this.localData.work_period_to = moment(_workPeriodToString).format(
        "YYYY-MM-DD"
      );
      this.setDuplicateDates();
    },

    inputTemplate(val) {
      this.localData = _.cloneDeep(val);

      const fromYear = moment()
        .local()
        .format("YYYY");
      const toYear = moment()
        .local()
        .add(this.localData.work_period_month, "month")
        .format("YYYY");
      this.localData.work_period_from = moment(
        `${fromYear}-${("00" + this.localData.work_period_from_month).slice(
          -2
        )}-${("00" + this.localData.work_period_from_day).slice(-2)}T00:00:00`
      ).format("YYYY-MM-DD");
      this.localData.work_period_to = moment(
        `${toYear}-${("00" + this.localData.work_period_to_month).slice(-2)}-${(
          "00" + this.localData.work_period_to_day
        ).slice(-2)}T00:00:00`
      ).format("YYYY-MM-DD");

      this.selectedTemplate = _.cloneDeep(val);
      this.setLocalDataParam();
    },

    setLocalDataParam() {
      this.overtimeLaborAgrmt = this.localData.overtime_labor_agrmt
        ? "有"
        : "無";
      this.compensatoryTimeOffLaborAgrmt = this.localData
        .compensatory_time_off_labor_agrmt
        ? "有"
        : "無";
      this.breakLaborAgrmt = this.localData.break_labor_agrmt ? "有" : "無";
      this.mandatoryDayOff = this.localData.mandatory_day_off ? "有" : "無";
      this.marinersLawArt72Applicable = this.localData
        .mariners_law_art_72_applicable
        ? "有"
        : "無";

      this.WorkPeriodMonth = {
        label: `${this.localData.work_period_month}ヶ月`,
        value: this.localData.work_period_month,
      };

      this.maxWorkHourPerDay = {
        label: this.localData.max_work_hour_per_day
          ? `${this.localData.max_work_hour_per_day}時間`
          : null,
        value: this.localData.max_work_hour_per_day,
      };

      const fromYear = moment(this.localData.work_period_from).format("YYYY");
      const fromMonth = moment(this.localData.work_period_from).format("MM");
      const fromDay = moment(this.localData.work_period_from).format("DD");
      const toYear = moment(this.localData.work_period_to).format("YYYY");
      const toMonth = moment(this.localData.work_period_to).format("MM");
      const toDay = moment(this.localData.work_period_to).format("DD");

      this.workingPeriodFromYear = {
        label: fromYear,
        value: parseInt(fromYear),
      };
      this.workingPeriodFromMonth = {
        label: fromMonth,
        value: parseInt(fromMonth),
      };
      this.workingPeriodFromDay = { label: fromDay, value: parseInt(fromDay) };
      this.workingPeriodToYear = { label: toYear, value: parseInt(toYear) };
      this.workingPeriodToMonth = { label: toMonth, value: parseInt(toMonth) };
      this.workingPeriodToDay = { label: toDay, value: parseInt(toDay) };
    },

    validateMandatoryDayOff() {
      this.$validator.errors.remove("custom_num_of_mandatory_day_off");
      if (!this.localData.mandatory_day_off) return true;

      if (!this.localData.num_of_mandatory_day_off) {
        this.$validator.errors.add({
          field: "custom_num_of_mandatory_day_off",
          msg: `休日日数を定めている場合の日数は必須項目です`,
        });
      }

      return this.localData.num_of_mandatory_day_off;
    },

    validateMaxWorkHourPerDay() {
      this.$validator.errors.remove("max_work_hour_per_day");
      if (!this.localData.mariners_law_art_72_applicable) return true;

      if (!this.localData.max_work_hour_per_day) {
        this.$validator.errors.add({
          field: "max_work_hour_per_day",
          msg: `1日あたり労働時間上限は必須項目です`,
        });
      }

      return this.localData.max_work_hour_per_day;
    },

    onCancel() {
      this.localData = {};
      this.$nextTick(() => {
        this.$emit("close");
      });
    },

    setDuplicateDates() {
      if (!this.localData.work_period_from || !this.localData.work_period_to)
        return [];
      if (!this.labors || this.labors.length === 0) return [];

      const duplicate_dates = [];

      //基準労働期間の重複チェック
      this.labors.forEach(item => {
        //労務情報が変更対象（idが同じ）の場合はチェックしない
        if (item.id === this.localData.id) return;

        const checkDuplicateFrom = DateUtil.isBetween(
          item.work_period_from,
          this.localData.work_period_from,
          this.localData.work_period_to
        );
        const checkDuplicateTo = DateUtil.isBetween(
          item.work_period_to,
          this.localData.work_period_from,
          this.localData.work_period_to
        );

        if (checkDuplicateFrom || checkDuplicateTo) {
          const duplicateDate = {
            item: `${item.work_period_from} - ${item.work_period_to}`,
            from: checkDuplicateFrom
              ? item.work_period_from
              : this.localData.work_period_from,
            to: checkDuplicateTo
              ? item.work_period_to
              : this.localData.work_period_to,
          };
          duplicate_dates.push(duplicateDate);
        }
      });

      this.duplicateDates = duplicate_dates.reverse();
    },

    async create(payload) {
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE });

        const res = await this.addLabor(payload);
        if (res.status) {
          this.$vs.notify({
            title: `労務基本情報追加`,
            text: `${this.crewName}の労務情報を追加しました`,
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
          });
        } else {
          const msg = `労務情報の追加に失敗しました。時間を空けて再度試みてください。`;
          this.$vs.notify({
            title: `労務基本情報追加`,
            text: msg,
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
          });
        }
        this.$vs.loading.close();
      } catch (error) {
        console.error(error);
        this.$vs.loading.close();
        const msg = `労務情報の追加に失敗しました。時間を空けて再度試みてください。`;
        this.$vs.notify({
          title: `労務基本情報追加`,
          text: msg,
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
        });
      }
    },
    async update(payload) {
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE });

        const res = await this.updateLabor(payload);
        if (res.status) {
          this.$vs.notify({
            title: `労務基本情報更新`,
            text: `${this.crewName}の労務情報を更新しました`,
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
          });
        } else {
          const msg = `労務情報の更新に失敗しました。時間を空けて再度試みてください。`;
          this.$vs.notify({
            title: `労務基本情報更新`,
            text: msg,
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
          });
        }
        this.$vs.loading.close();
      } catch (error) {
        console.error(error);
        this.$vs.loading.close();
        const msg = `労務情報の更新に失敗しました。時間を空けて再度試みてください。`;
        this.$vs.notify({
          title: `労務基本情報更新`,
          text: msg,
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
        });
      }
    },

    async onSubmit() {
      let checkValidate = await this.$validator.validateAll();
      if (!checkValidate) return;

      const payload = {
        break_labor_agrmt: this.localData.break_labor_agrmt,
        compensatory_time_off_labor_agrmt: this.localData
          .compensatory_time_off_labor_agrmt,
        labor_mgmt_rep: this.localData.labor_mgmt_rep,
        mandatory_day_off: this.localData.mandatory_day_off,
        mariners_law_art_72_applicable: this.localData
          .mariners_law_art_72_applicable,
        max_work_hour_per_day: this.localData.max_work_hour_per_day,
        num_of_mandatory_day_off: this.localData.num_of_mandatory_day_off,
        num_of_mandatory_paid_time_off: this.localData
          .num_of_mandatory_paid_time_off,
        overtime_labor_agrmt: this.localData.overtime_labor_agrmt,
        id: this.laborId,
        template_id: this.selectedTemplate ? this.selectedTemplate.id : null,
        work_period_from: this.localData.work_period_from,
        work_period_month: this.localData.work_period_month,
        work_period_to: this.localData.work_period_to,
        version: this.version || 0,
      };

      if (this.inputParam.id) {
        await this.update(payload);
      } else {
        await this.create(payload);
      }

      await this.fetchCrew();
      await this.fetchLaborPeriodList();

      this.$emit("checkAlert");
      this.localData = {};
      this.$emit("close");
    },

    yearSelect() {
      //過去5年分、未来2年分、合計8年選択可能にする
      const startYear = moment()
        .subtract(5, "years")
        .format("YYYY");
      const yearCount = 8;

      return Array.from({ length: yearCount }, (_, index) => {
        return {
          label: `${parseInt(startYear) + index}`,
          value: parseInt(startYear) + index,
        };
      });
    },
    monthSelect() {
      return Array.from({ length: 12 }, (_, index) => {
        return {
          label: `0${index + 1}`.slice(-2),
          value: index + 1,
        };
      });
    },
    daySelect(year, month) {
      if (!month) return [];
      const endOfMonthDay = parseInt(
        moment(`${year}${month}01`, "YYYYMMDD")
          .endOf("month")
          .format("D")
      );

      return Array.from({ length: endOfMonthDay }, (_, index) => {
        return {
          label: `0${index + 1}`.slice(-2),
          value: index + 1,
        };
      });
    },
    boolSelect() {
      return ["有", "無"];
    },
    selectedBoolItem(data) {
      const item = this.boolSelect();
      return item.find(item => item.value === data);
    },

    inputFromMonth() {
      if (!this.workingPeriodFromMonth.value) return true;
      return (
        this.workingPeriodFromMonth.value < 1 ||
        this.workingPeriodFromMonth.value > 12
      );
    },
    inputToMonth() {
      if (!this.workingPeriodToMonth.value) return true;
      return (
        this.workingPeriodToMonth.value < 1 ||
        this.workingPeriodToMonth.value > 12
      );
    },

    inputFromYear() {
      this.localData.work_period_from_year = this.workingPeriodFromYear;
    },

    inputToYear() {
      this.localData.work_period_to_year = this.workingPeriodToYear;
    },

    inputWorkPeriodMonth() {
      this.localData.work_period_month = this.WorkPeriodMonth.value;
    },

    inputOvertimeLaborAgrmt() {
      this.localData.overtime_labor_agrmt = this.overtimeLaborAgrmt === "有";
    },

    inputCompensatoryTimeOffLaborAgrmt() {
      this.localData.compensatory_time_off_labor_agrmt =
        this.compensatoryTimeOffLaborAgrmt === "有";
    },

    inputBreakLaborAgrmt() {
      this.localData.break_labor_agrmt = this.breakLaborAgrmt === "有";
    },

    inputMandatoryDayOff() {
      this.localData.mandatory_day_off = this.mandatoryDayOff === "有";
      if (this.localData.mandatory_day_off === false) {
        this.localData.num_of_mandatory_day_off = null;
      }
    },

    inputMarinersLawArt72Applicable() {
      this.localData.mariners_law_art_72_applicable =
        this.marinersLawArt72Applicable === "有";
      if (this.localData.mariners_law_art_72_applicable === false) {
        this.localData.max_work_hour_per_day = null;
        this.maxWorkHourPerDay = null;
      }
    },

    inputMaxWorkHourPerDay() {
      this.localData.max_work_hour_per_day = this.maxWorkHourPerDay.value;
      this.validateMaxWorkHourPerDay();
    },

    setDuplicateWorkPeriod(date) {
      this.duplicateWorkPeriodFrom = date.from
        ? DateUtil.toYMD_ja(date.from)
        : DateUtil.toYMD_ja(this.localData.work_period_from);
      this.duplicateWorkPeriodTo = date.to
        ? DateUtil.toYMD_ja(date.to)
        : DateUtil.toYMD_ja(this.localData.work_period_to);
    },

    setLatestData() {
      // 起算日を最新の労務情報の末尾に設定
      const latestLabor = _.cloneDeep(this.inputParam.latestLabor);

      this.localData = _.cloneDeep(latestLabor.template);
      this.selectedTemplate = latestLabor.template;

      if ("work_period_to" in latestLabor) {
        this.localData.work_period_from = moment(latestLabor.work_period_to)
          .add(1, "days")
          .format("YYYY-MM-DD");
      }

      this.setLocalDataParam();
    },

    setCreateData() {
      if (this.inputParam.latestLabor) {
        this.setLatestData();
        return;
      }

      if (!this.defaultTemplate) return;
      this.selectedTemplate = this.defaultTemplate;
      this.inputTemplate(this.defaultTemplate);
    },

    setUpdateData() {
      this.localData = _.cloneDeep(this.inputParam);
      this.laborId = this.inputParam.id;
      this.version = this.inputParam.version;
      this.selectedTemplate = this.localData.template;
      this.setLocalDataParam();
    },
  },
  async created() {
    await this.fetchTemplateList();
    if (this.inputParam.id) {
      this.setUpdateData();
    } else {
      this.setCreateData();
    }

    this.setDuplicateDates();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.crew-labor-edit {
  .disabled-area {
    color: $aisea-mouse-gray;
  }
  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .description_label {
    font-size: 0.8rem;
  }

  .vs-inputx {
    color: $aisea-dark-gray !important;
    font-family: $aisea-font-family;
    font-size: 16px !important;
    font-weight: 400;
  }
  .vs-input--placeholder {
    color: $aisea-slightly-gray !important;
  }

  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2rem;
    }
  }

  .crew-edit-form-row {
    flex-direction: column;
    margin: 24px 0;
    padding-right: 8px;

    label {
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .vs__search::placeholder {
    color: #d3d3d3;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
  }

  .vs-collapse-item--header {
    padding: 0;
  }
}
</style>
